module.exports = __webpack_public_path__ + "img/banner1.2883f1f5.png";